import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import { CheckBox, Select } from '../../Form';
import { allowedPushBackTimePeriodIncrements } from '../../../utils/courtSchedular';

import styles from './confirmPauseMatchPopup.scss';

const ConfirmPauseMatchPopup = (props) => {
    const {
        onCloseClick,
        onConfirmPause,
    } = props;

    const [pushBackFollowingMatches, setPushBackFollowingMatches] = useState(false);
    const [pushBackTimeDuration, setPushBackTimeDuration] = useState(0);

    const onCheckChange = (checked, ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        setPushBackFollowingMatches(checked);
    };

    const onChangePushBachTime = (value) => {
        setPushBackTimeDuration(value || 0);
    };

    const onConfirmClick = () => {
        const pushBackValue = parseInt(pushBackTimeDuration) > 0 ? parseInt(pushBackTimeDuration) : null;
        onConfirmPause(pushBackValue);
    };

    const disablePauseConfirm = pushBackFollowingMatches ? parseInt(pushBackTimeDuration) === 0 : false;

    return (
        <Popup
            className="popup-sm"
            popUpClassName={styles.confirmPauseMatchPopup}
            onCloseClick={onCloseClick}
            closeOnClickOutside={false}
            config={{
                fullScreen: false,
                noPadding: false,
                scrollable: false,
                showCloseIcon: false,
            }}
        >
            <div className={styles.header}>
                Pause selected match(es)?
            </div>
            <div className={`${styles.description} mt8`}>
                {'A "Paused" label will appear on selected match cards. To resume, click the play icon on the card.'}
            </div>
            <div className={`mt8`}>
                <CheckBox
                    id={`push-matches`}
                    formGroupCssClass={`${styles.pushBackSelect}`}
                    controlled={true}
                    checked={pushBackFollowingMatches}
                    onChange={onCheckChange}
                    customLabel="Push back subsequent matches"
                />
            </div>
            {!pushBackFollowingMatches && (
                <div className={`${styles.description} mt4 ml24`}>
                    Matches with specific time(s) added will have their times updated on schedules and draws.
                </div>
            )}
            {pushBackFollowingMatches && (
                <Select
                    attributeToShow="label"
                    attributeToSave="id"
                    themeV3
                    options={allowedPushBackTimePeriodIncrements}
                    formGroupCssClass={`${styles.pushBackSelect} mt8 ml24`}
                    controlled
                    value={pushBackTimeDuration}
                    onChange={onChangePushBachTime}
                />
            )}
            <div className={`${styles.footer} d-flex`}>
                <button
                    className={'btn btn-default mr8 flex-1'}
                    type="button"
                    onClick={onCloseClick}
                >
                    No, Cancel
                </button>
                <button
                    className={`btn btn-primary flex-1`}
                    type="button"
                    onClick={onConfirmClick}
                    disabled={disablePauseConfirm}
                >
                    Yes, Pause
                </button>
            </div>
        </Popup>
    );
};

ConfirmPauseMatchPopup.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    onConfirmPause: PropTypes.func.isRequired,
};

ConfirmPauseMatchPopup.defaultProps = {
};

export default ConfirmPauseMatchPopup;
